import { useState, useEffect, useReducer, useContext } from "react";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const reducer = (state, action) => {
  if (action.type === "LOAD_TELEGRAMS") {
    const telegrams = action.payload;
    // Ensure telegrams is an array
    if (Array.isArray(telegrams)) {
      return [...telegrams];
    }
    return [];
  }

  if (action.type === "UPDATE_TELEGRAMS") {
    const telegram = action.payload;
    const telegramIndex = state.findIndex((s) => s.id === telegram.id);

    if (telegramIndex !== -1) {
      state[telegramIndex] = telegram;
      return [...state];
    } else {
      return [telegram, ...state];
    }
  }

  if (action.type === "UPDATE_SESSION") {
    const telegram = action.payload;
    const telegramIndex = state.findIndex((s) => s.id === telegram.id);

    if (telegramIndex !== -1) {
      state[telegramIndex].status = telegram.status;
      state[telegramIndex].updatedAt = telegram.updatedAt;
      return [...state];
    } else {
      return [...state];
    }
  }

  if (action.type === "DELETE_TELEGRAMS") {
    const telegramId = action.payload;
    const telegramIndex = state.findIndex((s) => s.id === telegramId);
    if (telegramIndex !== -1) {
      state.splice(telegramIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useTelegrams = () => {
  const [telegrams, dispatch] = useReducer(reducer, []);
  const [loading, setLoading] = useState(true);
  const { user, socket } = useContext(AuthContext);

  // Effect para carregar os dados iniciais
  useEffect(() => {
    setLoading(true);
    const fetchSession = async () => {
      try {
        // Verificar se o usuário está autenticado antes de fazer a requisição
        const token = localStorage.getItem("token");
        if (!token) {
          setLoading(false);
          return;
        }
        
        const { data } = await api.get("/telegram/");
        dispatch({ type: "LOAD_TELEGRAMS", payload: data.telegrams || [] });
        setLoading(false);
      } catch (err) {
        // Silenciar erro se for de autenticação
        if (err?.response?.status !== 401 && err?.response?.status !== 403) {
          console.error("Erro ao carregar Telegrams:", err);
        }
        setLoading(false);
      }
    };
    fetchSession();
  }, []);

  // Effect para configurar os listeners do socket
  useEffect(() => {
    // Debug para entender o que está chegando
    console.log('useTelegrams - Debug:', {
      userId: user?.id,
      companyId: user?.companyId,
      socket: socket,
      socketType: typeof socket,
      hasOnMethod: socket && typeof socket.on === 'function',
      hasOffMethod: socket && typeof socket.off === 'function'
    });

    if (user?.companyId && socket && typeof socket.on === 'function' && typeof socket.off === 'function') {
      const companyId = user.companyId;
      
      const onCompanyTelegram = (data) => {
        console.log('Recebido evento telegram:', data);
        if (data.action === "update") {
          dispatch({ type: "UPDATE_TELEGRAMS", payload: data.telegram });
        }
        if (data.action === "delete") {
          dispatch({ type: "DELETE_TELEGRAMS", payload: data.telegramId });
        }
      };

      const onCompanyTelegramSession = (data) => {
        console.log('Recebido evento telegram session:', data);
        if (data.action === "update") {
          dispatch({ type: "UPDATE_SESSION", payload: data.session });
        }
      };

      const telegramEvent = `company-${companyId}-telegram`;
      const sessionEvent = `company-${companyId}-telegramSession`;

      console.log('Registrando listeners Telegram:', { telegramEvent, sessionEvent });

      socket.on(telegramEvent, onCompanyTelegram);
      socket.on(sessionEvent, onCompanyTelegramSession);

      return () => {
        if (socket && typeof socket.off === 'function') {
          console.log('Removendo listeners Telegram:', { telegramEvent, sessionEvent });
          socket.off(telegramEvent, onCompanyTelegram);
          socket.off(sessionEvent, onCompanyTelegramSession);
        }
      };
    } else {
      console.log('Condições não atendidas para listeners Telegram:', {
        hasCompanyId: !!user?.companyId,
        hasSocket: !!socket,
        hasOnMethod: socket && typeof socket.on === 'function',
        hasOffMethod: socket && typeof socket.off === 'function'
      });
    }
  }, [socket, user?.companyId]); // Dependências corretas

  return { telegrams, loading };
};

export default useTelegrams;